var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import IconContainer from "./IconContainer";
export var CaretIconDirections;
(function (CaretIconDirections) {
    CaretIconDirections["Top"] = "top";
    CaretIconDirections["Right"] = "right";
    CaretIconDirections["Bottom"] = "bottom";
    CaretIconDirections["Left"] = "left";
})(CaretIconDirections || (CaretIconDirections = {}));
const NewCaretIcon = (_a) => {
    var { className, size, direction, title } = _a, props = __rest(_a, ["className", "size", "direction", "title"]);
    let rotate = 0;
    if (direction === CaretIconDirections.Bottom)
        rotate = 90;
    else if (direction === CaretIconDirections.Left)
        rotate = 180;
    else if (direction === CaretIconDirections.Top)
        rotate = 270;
    return (React.createElement(IconContainer, Object.assign({ className: classNames("gerudo-icon-cancel-circle", size, className) }, props),
        React.createElement("title", null, title),
        React.createElement("svg", { width: "7", height: "12", viewBox: "0 0 7 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { transform: `rotate(${rotate}deg)` } },
            React.createElement("path", { d: "M1.33301 10.1667L5.49967 6.00004L1.33301 1.83337", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))));
};
NewCaretIcon.defaultProps = {
    title: "Cancel",
};
export default NewCaretIcon;
export { NewCaretIcon };
//# sourceMappingURL=NewCaret.js.map